import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select/creatable'
import { selectStyles } from 'apps/builder/components/shared'
import { StandardPdfSettings } from 'apps/builder/components/settings/modal/shared'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  createReferenceDataEntry,
  updateReferenceDataEntry,
  deleteReferenceDataEntry,
} from 'apps/builder/store/actions/referenceData'
import {
  referenceImagesSelector,
  doesFieldContainRefDataSelector,
} from 'apps/builder/store/selectors'
import { BasicMoreSettings } from './BasicMoreSettings'

export const DrawingMoreSettings = entry => {
  return (
    <>
      <div className="settings--row">
        <ReferenceImageDropdown {...entry} />
      </div>
      <StandardPdfSettings {...entry} />
      <BasicMoreSettings
        mobileVisible={false}
        pageBreakAfter={false}
        placeValueIn={false}
        {...entry}
      />
    </>
  )
}

const ReferenceImageDropdown = ({ guid, label, reference_data_id }) => {
  const referenceImages = useSelector(referenceImagesSelector)
  const doesFieldContainRefImage = useSelector(doesFieldContainRefDataSelector)
  const dispatch = useDispatch()

  const options = useMemo(() => {
    return [{ value: '', label: 'None' }].concat(
      referenceImages
        .map(({ id, name }) => ({ value: id, label: name }))
        .sort((a, b) => a.label.localeCompare(b.label))
    )
  }, [referenceImages])

  const value = options.find(({ value }) => value === reference_data_id) || options[0]

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        options={options}
        value={value}
        onChange={({ value }) => {
          if (value) {
            const createOrUpdateRefDataEntry = doesFieldContainRefImage
              ? updateReferenceDataEntry
              : createReferenceDataEntry

            dispatch(
              createOrUpdateRefDataEntry({
                guid,
                label,
                reference_data_id: value,
              })
            )
          } else {
            dispatch(deleteReferenceDataEntry({ guid: guid }))
          }

          dispatch(
            updateEntry({ guid, reference_data_id: value })
          )
        }}
      />
      <label>Reference Image</label>
    </div>
  )
}
